import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';
import SectionTitle from '@/components/base/SectionTitle';
import ComicCard from '@/components/base/ComicCard';

export default function HotSeries() {
  const hotComics = comics.filter((c) => c.isHot);

  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14">
          <SectionTitle
            label="/ 热门连载"
            title="人气爆款 · 每日极速更新"
            align="left"
          />
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors whitespace-nowrap mt-2 md:mt-0"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {hotComics.map((comic, index) => (
            <ComicCard
              key={comic.slug}
              slug={comic.slug}
              title={comic.title}
              author={comic.author}
              cover={comic.cover}
              rating={comic.rating}
              status={comic.status}
              latestChapter={comic.chapters[0]?.number}
            />
          ))}
        </div>

        <div className="mt-14 md:mt-20">
          <SectionTitle
            label="/ 分类浏览"
            title="探索你喜欢的漫画类型"
            align="center"
          />

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to="/category/all"
                className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-xl hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <span className="text-foreground-700 text-sm font-medium whitespace-nowrap">{cat.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}